module.exports = __webpack_public_path__ + "static/media/tom-3.5745a105.mp3";